import { Skeleton } from "@/components/ui/skeleton";
import { SiteHeader } from "@/components/site-header";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";

export function PlatformTeamLoading() {
    return (
        <div className="flex flex-col h-full">
            <SiteHeader
                title="Platform Team"
                subtitle="Manage developers and managers with organization access"
            >
                {/* Search skeleton */}
                <Skeleton className="h-9 w-[300px]" />
                {/* Filter skeletons */}
                <Skeleton className="h-9 w-[160px]" />
                <Skeleton className="h-9 w-[180px]" />
                {/* Button skeleton */}
                <Skeleton className="h-9 w-[130px]" />
            </SiteHeader>

            <div className="flex-1 overflow-auto">
                <div className="px-4 py-6 md:px-8 md:py-8">
                    {/* Table skeleton */}
                    <div className="rounded-md border shadow-sm">
                        <Table>
                            <TableHeader>
                                <TableRow className="bg-muted/50">
                                    <TableHead className="w-[280px]">User</TableHead>
                                    <TableHead className="w-[130px]">Role</TableHead>
                                    <TableHead className="w-[150px]">Status</TableHead>
                                    <TableHead className="w-[150px]">Organizations</TableHead>
                                    <TableHead className="w-[140px] text-right">Actions</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <TableRow key={i}>
                                        <TableCell>
                                            <div className="flex items-center gap-3">
                                                <Skeleton className="h-9 w-9 rounded-full" />
                                                <div className="space-y-2">
                                                    <Skeleton className="h-4 w-32" />
                                                    <Skeleton className="h-3 w-48" />
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton className="h-6 w-24 rounded-full" />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton className="h-6 w-20 rounded-full" />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton className="h-4 w-16" />
                                        </TableCell>
                                        <TableCell>
                                            <div className="flex justify-end gap-1">
                                                <Skeleton className="h-8 w-8" />
                                                <Skeleton className="h-8 w-8" />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
}
